var render = function render(){var _vm=this,_c=_vm._self._c;return _c('three-step-approval',{attrs:{"api":"home-status-request","perm-prefix":"approve_status_home","columns":_vm.columns,"final-word":"ປິດ/ເປີດ","final-icon":"mdi-swap-horizontal","final-confirm":(n) => `ປິດ/ເປີດສາຍບ້ານ ${n} ລາຍ? ເປີດ (active) ຈະເກັບໄດ້, ປິດ (inactive) ຈະເກັບບໍ່ໄດ້.`}})
}
var staticRenderFns = []

export { render, staticRenderFns }